import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>If there is not enough pressure on people, they are likely to
                                                ‘rust out’ and this can be just as
                                                stressful as too much pressure. However, under too much pressure
                                                people are likely to ‘burn out’.
                                                From a wellbeing perspective, in order to enable people to
                                                perform at their best, you need to get
                                                the level of pressure right, which importantly includes the
                                                level of challenge offered.</p>
                                            <p>Now look at this again, but in conjunction with support. This
                                                involves getting the best out of
                                                ourselves and others and relies on the right balance of support
                                                and challenge. This means
                                                providing encouragement and recognition whilst being prepared to
                                                point out discrepancies and
                                                ask questions.</p>
                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/moto_wee_img2.png')}/>
                                            </div>
                                            <p>This is another model by Robertson-Cooper<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>3</sup></a> which
                                                illustrates that if you apply pressure and challenge people,
                                                provided you give them support at the same time, the result can
                                                be peak performance. Without support, the result is stress. If,
                                                therefore, you challenge somebody beyond their comfort zone,
                                                whether in a developmental or performance context, adequate
                                                support is needed to achieve success.</p>
                                            <p>One of the key things is to establish as a manager how much
                                                support you provide. People are not dramatically different from
                                                one another, but if their preferences for low or high support
                                                are not recognised they may ‘burn out’ from being over
                                                challenged or ‘rust out’ through being over supported. Both
                                                diagrams show the importance of support and challenge to get
                                                employees into a position of peak performance.</p>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">STRENGTHS AND RISKS</span>
                                            </div>
                                            <p>The table overleaf will give you a chance to think back on some
                                                situations where you needed to challenge and/or support at work.
                                                Firstly, you will need to think of some situations in the past
                                                where a colleague was engaging in non-ideal behaviour and you
                                                felt that you needed to intervene (regardless of whether you did
                                                or didn’t).</p>
                                            <p>Once you have thought of a few examples, you can use your own
                                                experiences of the situation, and what you’ve learned from this
                                                tool to put down what, if any, challenge and support is needed.
                                                We’ve provided one hypothetical example to get you started.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}